<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Accounts',
        route: { name: 'customerservice-accounts' }
      }
    }
  }
}
</script>
